var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChildFormModel',{attrs:{"add-action":_vm.addAction,"update-action":_vm.updateAction,"delete-action":_vm.deleteAction,"view-action":_vm.viewAction,"category":"ISSUE"}})}
var staticRenderFns = []

export { render, staticRenderFns }